import React from "react";

const HeaderAboutIcon = ({ className }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			className={className}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.8053 6.19751C13.9669 2.35909 8.32576 2.02227 5.18948 5.15855C2.05319 8.29484 2.39002 13.936 6.22844 17.7744C10.0669 21.6128 15.708 21.9497 18.8443 18.8134C21.9806 15.6771 21.6438 10.0359 17.8053 6.19751ZM3.53161 3.50068C7.64343 -0.611141 14.7338 0.0320052 19.3523 4.65055C23.9708 9.26909 24.614 16.3594 20.5022 20.4712C16.3903 24.5831 9.30002 23.9399 4.68147 19.3214C0.0629298 14.7028 -0.580216 7.61251 3.53161 3.50068Z"
				fill="url(#paint0_linear_12440_10633)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 2.34458C6.66746 2.34458 2.34458 6.66746 2.34458 12C2.34458 17.3325 6.66746 21.6554 12 21.6554C17.3325 21.6554 21.6554 17.3325 21.6554 12C21.6554 6.66746 17.3325 2.34458 12 2.34458ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
				fill="url(#paint1_linear_12440_10633)"
			/>
			<path
				d="M13.0259 6.67119L12.8127 6.45805H11.2354V9.0584H8.72035V10.8488H11.2354V18.1383H13.0259V10.8488H15.541V9.22892L15.3278 9.0584H13.0259V6.67119Z"
				fill="url(#paint2_linear_12440_10633)"
			/>
			<path
				d="M13.0259 6.67119L12.8127 6.45805H11.2354V9.0584H8.72035V10.8488H11.2354V18.1383H13.0259V10.8488H15.541V9.22892L15.3278 9.0584H13.0259V6.67119Z"
				fill="url(#paint3_linear_12440_10633)"
			/>
			<path
				d="M12.8122 9.059H15.3272V10.6359H12.8122V18.1383H11.2346V10.6359H8.71961V9.059H11.2346V6.45804L12.8127 6.45805L12.8122 9.059Z"
				fill="url(#paint4_linear_12440_10633)"
			/>
			<path
				d="M12.8122 9.059H15.3272V10.6359H12.8122V18.1383H11.2346V10.6359H8.71961V9.059H11.2346V6.45804L12.8127 6.45805L12.8122 9.059Z"
				fill="url(#paint5_linear_12440_10633)"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_12440_10633"
					x1="22.8277"
					y1="4.34814"
					x2="1.17229"
					y2="18.0107"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0.17" stopColor="#4A5DD3" />
					<stop offset="1" stopColor="#A696F6" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_12440_10633"
					x1="22.8277"
					y1="4.34814"
					x2="1.17229"
					y2="18.0107"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#A696F6" />
					<stop offset="1" stopColor="#4A5DD3" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_12440_10633"
					x1="23.25"
					y1="3.51968"
					x2="-0.41452"
					y2="17.9832"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#111111" />
					<stop offset="1" stopColor="#646464" />
				</linearGradient>
				<linearGradient
					id="paint3_linear_12440_10633"
					x1="22.8277"
					y1="4.34814"
					x2="1.17229"
					y2="18.0107"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0.31" stopColor="#4A5DD3" />
					<stop offset="1" stopColor="#A696F6" />
				</linearGradient>
				<linearGradient
					id="paint4_linear_12440_10633"
					x1="15.3274"
					y1="8.17099"
					x2="7.13328"
					y2="11.0956"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#646464" />
					<stop offset="1" stopColor="#111111" />
				</linearGradient>
				<linearGradient
					id="paint5_linear_12440_10633"
					x1="15.0046"
					y1="8.57418"
					x2="7.61101"
					y2="11.2131"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#A696F6" />
					<stop offset="1" stopColor="#4A5DD3" />
				</linearGradient>
			</defs>
		</svg>
	);
};

export default HeaderAboutIcon;
